<template>
  <p class="magical-question">
    What is the mystery of life?
  </p>
  <button class="magic-button" @click="findOutMore">
    Find out!
  </button>
  <br />
  <br />
  <p v-if="isMagicalAnswerVisible" class="magical-answer">
    "All life begins with Nu and ends with Nu. This is the truth! This is my belief! ...At least for now."
    <br />
    — "The Mystery of Life," vol. 841, chapter 26</p>
  <img v-if="isMagicalAnswerVisible" src="./assets/nu.gif" />
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        isMagicalAnswerVisible: false
      }
    },
    methods: {
      findOutMore() {
        this.isMagicalAnswerVisible = !this.isMagicalAnswerVisible
      }
    }
  }
</script>

<style>
html {
  background-color: #2c3e50;
}
button {
  font-size: 1.5em;
  padding: 0.5em 1.5em;
}
p {
  font-size: 1.1em;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  margin-top: 60px;
}
</style>
